import {
  Outlet,
  useLocation
} from "react-router";
import Footer from "./components/Footer";
import Header from "@components/Header";
import CookieConsent from "@components/CookieConsent";
import { ConsentManagerProvider } from "@c15t/react";

function Layout() {
  const { pathname } = useLocation();

  return (
    <main className="app-wrapper">
      <ConsentManagerProvider options={{mode: "offline"}}>
        <Header/>
        {/* New key on every route change replays the fade-in animation */}
        <div className="page-transition" key={pathname}>
          <Outlet />
          <Footer/>
        </div>
        <CookieConsent/>
      </ConsentManagerProvider>
    </main>
  );
}

export default Layout;
